export default __webpack_public_path__ + "static/media/beds.200adbad.jpg";